import { createSelector, createSlice } from '@reduxjs/toolkit';

import { AppState, InstallAppAction, LoadAppAction, SetAppAction } from './interface';
import { RootState } from 'store/rootReducer';

const initialState: AppState = {
  loadingStatus: 'loading',
  app: null,
  isInstalled: false,
};

export const { actions, reducer } = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    loadApp(state, _: LoadAppAction) {
      state.loadingStatus = 'loading';
    },
    setFailed(state) {
      state.loadingStatus = 'failed';
    },
    setApp(state, action: SetAppAction) {
      const { app, isInstalled } = action.payload;
      state.loadingStatus = '';
      state.app = app;
      state.isInstalled = isInstalled;
    },
    installApp(_, __: InstallAppAction) {},
    setAppInstalled(state) {
      state.isInstalled = true;
    },
  },
});

export { reducer as appReducer, actions as appActions };

export const appSelector = (state: RootState) => state.app;

export const appLoadingStatusSelector = createSelector(appSelector, (app) => {
  return app.loadingStatus;
});

export const appInfoSelector = createSelector(appSelector, (app) => {
  return app.app;
});
